import { render, staticRenderFns } from "./VendorAddOns.vue?vue&type=template&id=77c3823c&scoped=true"
import script from "./VendorAddOns.vue?vue&type=script&lang=js"
export * from "./VendorAddOns.vue?vue&type=script&lang=js"
import style0 from "./VendorAddOns.vue?vue&type=style&index=0&id=77c3823c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c3823c",
  null
  
)

export default component.exports